import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  SimpleGrid,
  Heading,
  useToast,
  Spinner,
  VStack,
  Text,
  HStack,
  Icon,
  Divider,
} from '@chakra-ui/react';
import { MdWaterDrop, MdLocationOn, MdSettings } from 'react-icons/md';
import axios from 'axios';

const CrearActualizarToma = ({
  idPropietario,
  alta,
}: {
  idPropietario: number;
  alta: boolean;
}) => {
  const [formData, setFormData] = useState<any>({
    idGiro: '',
    idUbicacionRed: '1',
    idTarifa: '',
    idAbastecimiento: '1',
    idEstadoToma: '1',
    idDescarga: '1',
    idAlmacenamiento: '2',
    idContamina: '1',
    Cuenta: '',
    Subcuenta: 0,

    estado: 'TLAXCALA',
    poblacion: '',
    municipio: 'TOTOLAC',
    domicilio: '',
    tomas: 0,
    fechaInicioServicio: '',
    derivadasHabitacionales: 0,
    derivadasComerciales: 0,
    usuario: '',
    fechaAlta: new Date().toISOString().split('T')[0],

    observaciones: '',
    idUso: '',
    //idUsoPredio:'',
    idLocalidad: '',
    idServicio: '1', // Valor por defecto establecido como "1"
  });

  const [catalogos, setCatalogos] = useState<any>({
    cAbastecimiento: [],
    cAlmacenamiento: [],
    cContamina: [],
    cDescarga: [],
    cEstadoToma: [],
    cTarifa: [],
    cUbicacionRed: [],
    cGiro: [],
    cUso: [],
    cLocalidad: [],
    cServiciox: [],
  });

  const [loading, setLoading] = useState(true);
  const [adeudo, setAdeudo] = useState<any>(null); // Información del adeudo
  const toast = useToast();

  // Cargar catálogos y datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obtener catálogos
        const catalogosResponse = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cAbastecimiento`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cAlmacenamiento`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cContamina`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cDescarga`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cEstadoToma`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cTarifa`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cUbicacionRed`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cGiro`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cUsoPredioRoutes/agua`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cLocalidadRoutes`),
          axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cServicioRoutes`),
        ]);

        setCatalogos({
          cAbastecimiento: catalogosResponse[0].data,
          cAlmacenamiento: catalogosResponse[1].data,
          cContamina: catalogosResponse[2].data,
          cDescarga: catalogosResponse[3].data,
          cEstadoToma: catalogosResponse[4].data,
          cTarifa: catalogosResponse[5].data,
          cUbicacionRed: catalogosResponse[6].data,
          cGiro: catalogosResponse[7].data,
          cUso: catalogosResponse[8].data,
          cLocalidad: catalogosResponse[9].data,
          cServiciox: catalogosResponse[10].data,
        });

        try {
          // alert(alta)
          if (alta == false) {
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/tomasx/${idPropietario}`,
            );
            console.log(response);
            if (response.data) {
              const fechaFormateada = response.data.fechaAlta
                ? new Date(response.data.fechaAlta).toISOString().split('T')[0] // Convierte a YYYY-MM-DD
                : '';

              setFormData({
                ...response.data,
                fechaAlta: fechaFormateada, // Asegura que la fecha está en formato YYYY-MM-DD
              });
            } else {
              console.warn('No se encontraron datos para la toma');
            }
          }
        } catch (error) {
          console.error('Error al obtener los datos:', error);
        }

        // Obtener información del adeudo
        // const adeudoResponse = await axios.get(
        //   `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/adeudos?propietarioId=${idPropietario}`
        // );
        // setAdeudo(adeudoResponse.data);
      } catch (error) {
        toast({
          title: 'Error al cargar datos',
          description: 'No se pudieron cargar los datos necesarios.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idPropietario, toast]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    // Validación: Verifica si hay campos vacíos
    const requiredFields = [
      "idGiro",
      "idUbicacionRed",
      "idTarifa",
      "idAbastecimiento",
      "idEstadoToma",
      "idDescarga",
      "idAlmacenamiento",
      "idContamina",
      "Cuenta",
      "estado",
      "municipio",
      "domicilio",
      // "tomas",
      // "fechaInicioServicio",
      // "derivadasHabitacionales",
      // "derivadasComerciales",
      // "usuario",
      "fechaAlta",
      "idUso",
      "idLocalidad",
      "idServicio",
    ];
  
    const missingFields = requiredFields.filter((field) => !formData[field]);
  
    if (missingFields.length > 0) {
      toast({
        title: "Campos requeridos incompletos",
        description: `Por favor, llena los siguientes campos: ${missingFields.join(", ")}`,
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return; // Detiene la ejecución si faltan campos
    }
  
    try {
      if (formData.id) {
        // Actualizar con PUT
        await axios.put(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/tomasx/${formData.id}`, {
          ...formData,
          propietarioId: idPropietario,
        });
  
        toast({
          title: "Toma actualizada",
          description: "Los datos se actualizaron correctamente.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        // Crear nueva con POST
        const r = await axios.post(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/tomasx`, {
          ...formData,
          propietarioId: idPropietario,
        });

        // console.log(r.data.ESTADO)
        if(r.data.ESTADO=='ERROR')
          toast({
            title: "Error al guardar",
            description: "La toma ya existe",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          else
        toast({
          title: "Toma creada",
          description: "Los datos se registraron correctamente.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error la toma ya existe:", error);
      toast({
        title: "Error al guardar",
        description: "No se pudieron guardar los datos.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  

  const handlePay = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/pagos`, {
        propietarioId: idPropietario,
      });
      toast({
        title: 'Pago realizado',
        description: 'El adeudo ha sido pagado correctamente.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setAdeudo(null); // Actualizar estado para reflejar el pago
    } catch (error) {
      toast({
        title: 'Error al realizar el pago',
        description: 'No se pudo procesar el pago del adeudo.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  if (loading) {
    return (
      <Box textAlign="center" p={6}>
        <Spinner size="xl" />
        <Heading size="md" mt={4}>
          Cargando datos...
        </Heading>
      </Box>
    );
  }

  return (
    <Box p={6} bg="gray.50" borderRadius="xl">
      {/* Header */}
      <VStack spacing={4} align="stretch" mb={6}>
        <HStack spacing={3}>
          <Box
            p={3}
            bg="linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)"
            borderRadius="lg"
          >
            <Icon as={MdWaterDrop} color="white" boxSize={6} />
          </Box>
          <Box>
            <Heading size="md" color="#0891b2">
              {formData.id ? 'Actualizar Toma' : 'Alta de Toma'}
            </Heading>
            <Text fontSize="sm" color="gray.600">
              {formData.id ? 'Modifica los datos de la toma de agua' : 'Registra una nueva toma de agua potable'}
            </Text>
          </Box>
        </HStack>
        <Divider borderColor="gray.300" />
      </VStack>
      {adeudo && (
        <VStack
          spacing={4}
          mb={6}
          align="stretch"
          bg="gray.50"
          p={4}
          borderRadius="md"
        >
          <Text fontSize="lg" fontWeight="bold">
            Adeudo: ${adeudo.monto.toFixed(2)}
          </Text>
          <Text>{adeudo.descripcion}</Text>
          <Button colorScheme="red" onClick={handlePay}>
            Pagar
          </Button>
        </VStack>
      )}
      {/* Sección: Información General */}
      <Box mb={6}>
        <HStack spacing={2} mb={4}>
          <Icon as={MdSettings} color="#0891b2" boxSize={5} />
          <Heading size="sm" color="#0891b2">Información General</Heading>
        </HStack>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={4}>
          <FormControl isRequired>
            <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Giro</FormLabel>
            <Select
              name="idGiro"
              value={formData.idGiro}
              onChange={handleChange}
              bg="white"
              borderColor="gray.300"
              _hover={{ borderColor: "#0891b2" }}
              _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
            >
              <option value="">Seleccione una opción</option>
              {catalogos.cGiro.map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl isRequired>
            <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Uso</FormLabel>
            <Select
              name="idUso"
              value={formData.idUso}
              onChange={handleChange}
              bg="white"
              borderColor="gray.300"
              _hover={{ borderColor: "#0891b2" }}
              _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
            >
              <option value="">Seleccione una opción</option>
              {catalogos.cUso.map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

        <FormControl isRequired>
          <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Localidad</FormLabel>
          <Select
            name="idLocalidad"
            value={formData.idLocalidad}
            onChange={handleChange}
            bg="white"
            borderColor="gray.300"
            _hover={{ borderColor: "#0891b2" }}
            _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cLocalidad.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Servicio</FormLabel>
          <Select
            name="idServicio"
            value={formData.idServicio}
            onChange={handleChange}
            bg="white"
            borderColor="gray.300"
            _hover={{ borderColor: "#0891b2" }}
            _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cServiciox.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Tarifa</FormLabel>
          <Select
            name="idTarifa"
            value={formData.idTarifa}
            onChange={handleChange}
            bg="white"
            borderColor="gray.300"
            _hover={{ borderColor: "#0891b2" }}
            _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cTarifa.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Abastecimiento</FormLabel>
          <Select
            name="idAbastecimiento"
            value={formData.idAbastecimiento}
            onChange={handleChange}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cAbastecimiento.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Almacenamiento</FormLabel>
          <Select
            name="idAlmacenamiento"
            value={formData.idAlmacenamiento}
            onChange={handleChange}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cAlmacenamiento.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Contamina</FormLabel>
          <Select
            name="idContamina"
            value={formData.idContamina}
            onChange={handleChange}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cContamina.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Descarga</FormLabel>
          <Select
            name="idDescarga"
            value={formData.idDescarga}
            onChange={handleChange}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cDescarga.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Estado de Toma</FormLabel>
          <Select
            name="idEstadoToma"
            value={formData.idEstadoToma}
            onChange={handleChange}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cEstadoToma.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>

        {/* <FormControl isRequired>
          <FormLabel>Ubicación Red</FormLabel>
          <Select
            name="idUbicacionRed"
            value={formData.idUbicacionRed}
            onChange={handleChange}
          >
            <option value="">Seleccione una opción</option>
            {catalogos.cUbicacionRed.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </Select>
        </FormControl> */}

        <FormControl isRequired>
          <FormLabel>Estado</FormLabel>
          <Input
            type="text"
            name="estado"
            value={formData.estado}
            onChange={handleChange}
            isDisabled
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Municipio</FormLabel>
          <Input
            type="text"
            name="municipio"
            value={formData.municipio}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Subcuenta (Generada automáticamente)</FormLabel>
          <Input
            type="number"
            name="Subcuenta"
            value={formData.Subcuenta}
            isReadOnly
            bg="gray.100"
          />
        </FormControl>
        <FormControl isRequired>
          <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Cuenta</FormLabel>
          <Input
            type="text"
            name="Cuenta"
            value={formData.Cuenta}
            onChange={handleChange}
            bg="white"
            borderColor="gray.300"
            _hover={{ borderColor: "#0891b2" }}
            _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
          />
        </FormControl>
        </SimpleGrid>
      </Box>

      {/* Sección: Ubicación */}
      <Box mb={6}>
        <HStack spacing={2} mb={4}>
          <Icon as={MdLocationOn} color="#0891b2" boxSize={5} />
          <Heading size="sm" color="#0891b2">Ubicación</Heading>
        </HStack>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormControl isRequired>
            <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Domicilio</FormLabel>
            <Textarea
              name="domicilio"
              value={formData.domicilio}
              onChange={handleChange}
              bg="white"
              borderColor="gray.300"
              _hover={{ borderColor: "#0891b2" }}
              _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
            />
          </FormControl>

          <FormControl>
            <FormLabel color="gray.700" fontWeight="semibold" fontSize="sm">Observaciones</FormLabel>
            <Textarea
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              bg="white"
              borderColor="gray.300"
              _hover={{ borderColor: "#0891b2" }}
              _focus={{ borderColor: "#0891b2", boxShadow: "0 0 0 1px #0891b2" }}
            />
          </FormControl>
        </SimpleGrid>
      </Box>
      <Divider my={6} borderColor="gray.300" />
      <HStack spacing={4} justify="flex-end">
        <Button
          bg="linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)"
          color="white"
          _hover={{ transform: "translateY(-2px)", boxShadow: "lg" }}
          _active={{ transform: "translateY(0)" }}
          transition="all 0.2s"
          onClick={handleSubmit}
          px={8}
          leftIcon={<MdWaterDrop />}
        >
          {formData.id ? 'Actualizar Toma' : 'Crear Toma'}
        </Button>
      </HStack>
    </Box>
  );
};

export default CrearActualizarToma;
